import { esc } from "../ui/format.js";
import { uiGet } from "../ui/kit.js";
import { toast } from "../ui/modals.js";
import { emLetters, emLog, emRegister, emWireLetters } from "./empire.js";

/**
 * Release 1.7, the press (backend/press.py):
 *   News       you write the press release after a big event (tone: humble / bold / blame)
 *   Overview   the monthly CEO report card: A-F for growth, profit, people, risk, shareable
 */

const TONE = { A: "var(--sage)", B: "var(--neon-cyan)", C: "var(--neon-gold)", D: "#fb923c", F: "var(--oxblood)" };

function cardHtml(v) {
  const c = v.card;
  const hist = v.history.slice(-12);
  return `<div class="rc">
    <div class="rc-main" style="--g:${TONE[c.grade]}"><span>Month ${c.month}</span><b>${c.grade}</b><em>${Math.round(c.overall)}/100</em></div>
    <div class="rc-parts">${Object.entries(c.parts).map(([k, p]) => `<div class="rc-part" style="--g:${TONE[p.grade]}"><b>${p.grade}</b><span>${esc(k[0].toUpperCase() + k.slice(1))}</span><em>${esc(p.note)}</em></div>`).join("")}</div>
    ${hist.length > 1 ? `<div class="rc-hist" aria-label="Recent months">${hist.map((h) => `<i style="--g:${TONE[h.grade]}" title="Month ${h.month}: ${h.grade}">${h.grade}</i>`).join("")}</div>` : ""}
    <div class="em-actions"><button type="button" data-rc-share>Copy to share</button></div></div>`;
}

async function overviewPanel(host) {
  const v = await uiGet("/moves/press");
  if (!v.card) return null;
  host.innerHTML = `${emLetters(v.open)}${cardHtml(v)}`;
  emWireLetters(host);
  host.querySelector("[data-rc-share]").addEventListener("click", async () => {
    try { await navigator.clipboard.writeText(v.share_text); toast("Report card copied."); } catch (e) { toast(v.share_text); }
  });
  return { title: `CEO report card: ${v.card.grade}`, summary: Object.entries(v.card.parts).map(([k, p]) => `${k} ${p.grade}`).join(" · "), open: true, badge: v.open.length ? "📰" : "" };
}

async function newsPanel(host) {
  const v = await uiGet("/moves/press");
  host.innerHTML = `${emLetters(v.open, { empty: "No big story needs a statement right now. After an IPO, a deal, layoffs or a crisis, you'll write one here." })}
    <h4 class="mv-h">Your recent statements</h4>${emLog(v.releases, { emptyText: "None yet." })}`;
  emWireLetters(host);
  return { title: "Press office: write the press release", summary: v.open.length ? v.open[0].title : "Nothing waiting", open: v.open.length > 0, badge: v.open.length ? "!" : "" };
}

emRegister("overview", overviewPanel);
emRegister("news", newsPanel);

export { newsPanel, overviewPanel };
